<template>
  <div
    :class="[
      'product-detail-gallery',
      { 'product-detail-gallery--is-loading': isLoading }
    ]"
  >
    <div v-if="isLoading">
      <LoadingSkeleton class="product-detail-gallery__loading-image" />
    </div>
    <ul
      v-else-if="!isLoading && items.length > 0"
      class="product-detail-gallery__items"
    >
      <li
        v-for="(item, index) in items"
        :key="index"
        class="product-detail-gallery__item"
      >
        <button
          v-if="lightboxGallery"
          type="button"
          class="product-detail-gallery__item-btn"
          :aria-label="lightboxGallery.triggerBtnLabel"
          @click="lightboxGalleryRef?.openLightbox(index, $event)"
        >
          <Media :lazyload="index > 0" :media="item.media" :cols="[4, 3, 2]" />
        </button>
        <Media
          v-else
          :lazyload="index > 0"
          :media="item.media"
          :cols="[4, 3, 2]"
        />
      </li>
    </ul>
    <div
      v-if="$slots.default"
      class="product-detail-gallery__additional-content"
    >
      <slot />
    </div>
    <ClientOnly>
      <LightboxGallery
        v-if="lightboxGallery"
        ref="lightboxGalleryRef"
        v-bind="lightboxGallery"
      />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import {
  LightboxGallery,
  LoadingSkeleton,
  Media
} from '@hypercodestudio/basler-components';
import type {
  GalleryItem,
  LightboxGalleryInterface,
  LightboxGalleryHandle
} from '@hypercodestudio/basler-components';

interface Props {
  items: GalleryItem[];
  lightboxGallery?: LightboxGalleryInterface;
  isLoading?: boolean;
}

withDefaults(defineProps<Props>(), {
  isLoading: false,
  lightboxGallery: undefined
});

const lightboxGalleryRef = ref<LightboxGalleryHandle | null>(null);
</script>

<style scoped>
.product-detail-gallery__additional-content {
  display: flex;
  justify-content: center;
  margin-block-start: var(--spacing-size-medium);
}
</style>
